export default "__VITE_ASSET__jQfp96cf__"